<template>
  <div id="data-list-list-view" class="data-list-container">
    <edit-mail :base="base" :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
      :dispatcher="dispatcher" :charger="charger" :commercial="commercial" :agentCanQualify="agent_can_qualify"
      :requestIsFree="is_free" />
    <FilterMail :isPromptActive="filterPrompt" @closePrompt="toggleFilterPrompt" :users="users"
      :callBackFilter="callBackFilter" />

    <vs-table ref="table" :max-items="itemsPerPage" :data="requests">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            " @click="showFilter()">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Filtrer</span>
          </div>
          <div @click="refresh()" class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            ">
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input v-model="stringSearch" @keypress.enter="findRequests()" type="text"
            class="input-search vs-table--search-input" />
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Demande</vs-th>
        <vs-th sort-key="type">E-mail</vs-th>
        <vs-th sort-key="created_at">Date</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="40%">
              <span class="">{{ tr.title }} </span>
              <vs-chip v-if="tr.fromEmail">Email</vs-chip>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.email | title }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-price">{{ tr.created_at | title }}</p>
            </vs-td>

            <vs-td width="20%" class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Détails">
                  <div @click="addNewData(tr), selected_request = tr.id, checkIfAgentCanQualify()" class="flex">
                    <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-2" />
                  </div>
                </vx-tooltip>
                <vx-tooltip text="Archiver">
                  <div @click="archiver(tr)" class="flex">
                    <feather-icon icon="ArchiveIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2" />
                  </div>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
  </div>
</template>

<script>
import FilterMail from "./FilterMail";
var base_self;
var input_tempon = {
  id: null,
  name: "",
  files: [],
  img: null,
  contract: "",
  contract_id: "",
  priority_id: "",
  type_request_id: "",
  subtype_request_id: "",
  request_content: "",
  customer_id: "",
  again: false,
  user_assign: "",
  urgency_id: "",
  impact_id: "",
};

import EditMail from "./EditMail";
import { _buildQuery } from '../../../helpers/helper';

export default {
  components: {
    FilterMail,
    EditMail,
  },
  data() {
    return {
      dispatcher: false,
      commercial: false,
      users: [],
      filterPrompt: false,
      affiche: {
        title: "",
        email: "",
        content: "",
        upload: [],
      },
      last_page: 1,
      page: 1,
      customers_contracts: [],
      sub_categories_requests: [],

      priorities: [],
      categories_requests: [],
      customers: [],
      charger: [],

      input: JSON.parse(JSON.stringify(input_tempon)),
      input_second: JSON.parse(JSON.stringify(input_tempon)),
      selected: [],
      requestDatas: [],
      // requests: [],
      itemsPerPage: 50,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      stringSearch: "",
      agent_can_qualify: false,
      is_free: false,
      urgencies: [],
      impacts: [],
      stringSearch: "",
      selected_request: null
    };
  },
  watch: {
    page(value) {
      base_self.outlook(value, base_self.stringSearch);
    },
    input: {
      handler(val) {
        base_self.watch_input_ajout_handler(val);
      },
      deep: true,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.AppActiveUser.userRole === "admin";
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    requests() {
      return base_self.requestDatas;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.requests.length;
    },
    base() {
      return base_self;
    },
    input_tempon() {
      return input_tempon;
    },
  },
  methods: {
    async findRequests() {
      if (base_self.stringSearch) {
        try {
          base_self.$vs.loading();
          let params = {
            page: base_self.page,
            search: base_self.stringSearch,
          };
          let response = await base_self.$store.state
            .outlook({}, _buildQuery(params))
            .catch((error) => {
              console.log("error: ", error);
            });
          base_self.last_page = response.data.last_page;
          base_self.requestDatas = response.data.data;
          base_self.$vs.loading.close();
        } catch (error) {
          base_self.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        }
      } else {
        base_self.outlook(base_self.page, base_self.stringSearch);
      }
    },
    checkIfAgentCanQualify() {
      this.$vs.loading();
      this.$http
        .get("/outlook/check-agent-can-qualify")
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status == true) {
            this.agent_can_qualify = true;
            this.checkIsRequestIsFree();
          } else this.agent_can_qualify = false;
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    checkIsRequestIsFree() {
      // this.$vs.loading();
      this.$http
        .get("/outlook/check-is-request-free?id=" + this.selected_request)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status == true) {
            this.is_free = true;
          } else this.is_free = false;
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    freeRequest() {
      // this.$vs.loading();
      this.$http
        .post("/outlook/free-request", {
          id: this.selected_request
        })
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status == true) {
            this.is_free = true;
          } else this.is_free = false;
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },

    refresh() {
      base_self.page = 1;
      base_self.stringSearch = "";
      base_self.last_page = "";
      base_self.outlook(base_self.page, base_self.stringSearch);
    },

    getUsers() {
      base_self.$vs.loading();
      base_self.$http
        .get("/users?paginate=0&profile=3")
        .then((response) => {
          base_self.users = response.data;
          base_self.$vs.loading.close();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          base_self.$vs.loading.close();
          console.log(error);
        });
    },
    showFilter() {
      base_self.getUsers();
      this.filterPrompt = true;
    },
    callBackFilter(model, stringSearch) {
      base_self.page = 1;
      base_self.stringSearch = stringSearch;
      base_self.last_page = model.data.last_page;
      base_self.requestDatas = model.data.data;
    },
    watch_input_ajout_handler(val) {
      if (
        val.customer_id &&
        val.customer_id !== base_self.input_second.customer_id
      ) {
        base_self.getCustomers_contracts(val.customer_id);
      }

      if (
        val.type_request_id &&
        val.type_request_id !== base_self.input_second.type_request_id
      ) {
        base_self.getSub_categories_requests(val.type_request_id);
      }

      if (
        val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        var length = base_self.customers_contracts.length;

        for (let iuoy = 0; iuoy < length; iuoy++) {
          var item = base_self.customers_contracts[iuoy];
          if (val.contract_id === item.id) {
            base_self.input.contract = item.code_contract;
          }
        }
      } else if (
        !val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        if (base_self.customers_contracts.length) {
          base_self.input.contract_id = base_self.customers_contracts[0].id;
          base_self.input.contract =
            base_self.customers_contracts[0].code_contract;
        }
      }

      // if (
      //   val.priority_id &&
      //   val.priority_id !== base_self.input_second.priority_id
      // ) {
      //   base_self.getUrgenciesByPriority(val.priority_id);
      // }

      // if (
      //   val.urgency_id &&
      //   val.urgency_id !== base_self.input_second.urgency_id
      // ) {
      //   base_self.getImpactsByUrgence(val.priority_id, val.urgency_id);
      // }

      base_self.input_second = JSON.parse(JSON.stringify(base_self.input));
    },
    addNewData(data) {
      base_self.affiche.id = data.id;
      base_self.affiche.title = data.title;
      base_self.affiche.email = data.email;
      base_self.affiche.content = data.content;
      base_self.affiche.upload = data.upload;

      this.toggleDataSidebar(true);
      if (this.dispatcher) {
        this.getCharger();
      }
    },
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    getProgressionColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      if(val == false){
        this.freeRequest();
      }
    },
    goToSingle(id) {
      if (this.isAdmin) {
        this.$router.push("/requests/" + id + "/cc");
      } else {
        this.$router.push("/requests/" + id);
      }
    },
    async outlook(page, stringSearch) {
      base_self.$vs.loading();
      let response = await base_self.$store.state
        .outlook({}, _buildQuery({ page, stringSearch }))
        .catch((error) => {
          console.log("error: ", error);
        });
      base_self.last_page = response.data.last_page;
      base_self.requestDatas = response.data.data;
      base_self.$vs.loading.close();
    },
    async getPriorities() {
      let response = await base_self.$store.state
        .priorities({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.priorities = response.data;
    },
    async getCategories_requests() {
      let response = await base_self.$store.state
        .categories_requests({}, { paginate: 0 })
        .catch((error) => {
          console.log("error: ", error);
        });
      base_self.categories_requests = response.data;
    },
    async getSub_categories_requests(id) {
      let response = await base_self.$store.state
        .sub_categories_requests({}, id)
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.sub_categories_requests = response.data;
    },
    async getUrgenciesByPriority(id) {
      this.$vs.loading();
      this.$http
        .get("/requests/service-now/urgencies-by-priority?priority_id=" + id)
        .then((response) => {
          let values = response.data;
          base_self.urgencies = values;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        });
    },
    async getImpactsByUrgence(priority_id, urgency_id) {
      this.$vs.loading();
      this.$http
        .get(
          "/requests/service-now/impacts-by-urgency?priority_id=" +
          priority_id +
          "&urgency_id=" +
          urgency_id
        )
        .then((response) => {
          let values = response.data;
          base_self.impacts = values;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        });
    },
    async getCustomers() {
      let response = await base_self.$store.state
        .customers({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.customers = response.data;
    },
    async getCustomers_contracts(id) {
      let response = await base_self.$store.state
        .customers_contracts({}, id)
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.customers_contracts = response.data;
    },

    getCharger() {
      this.$vs.loading();
      this.$http
        .get("/users?paginate=0&profile=3")
        .then((response) => {
          this.charger = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          this.$vs.loading.close();
        });
    },

    archiver(archive) {
      if (confirm("Voulez vous archiver cette demande")) {
        this.$vs.loading();
        this.$http
          .post("/requests/archive", { id: archive.id })
          .then((response) => {
            this.$vs.loading.close();
            if (response.data.status) {
              let index = this.requests.indexOf(archive);
              this.requests.splice(index, 1);
              window.GETCCMT.success("Opération effectué.", response);
            } else {
              window.GETCCMT.error({ message: "L'opération a échouée." });
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push({ name: "login" });
            }
            this.$vs.loading.close();
          });
      }
    },
  },
  created() {
    base_self = this;
    window.MailRequestsApp = this;
  },
  async mounted() {
    this.isMounted = true;
    this.dispatcher = window.GETCCMT.$store.state.is_dispatcher();
    this.commercial = window.GETCCMT.$store.state.is_commercial();
    base_self.outlook(base_self.page, base_self.stringSearch);
    base_self.getPriorities();
    base_self.getCategories_requests();
    base_self.getCustomers();

    if (
      base_self.$store.state.is_client() ||
      base_self.$store.state.is_mandataire()
    ) {
      input_tempon.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      base_self.input.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      await base_self.getCustomers_contracts(
        base_self.$store.state.AppActiveUser.customer_id
      );

      if (base_self.customers_contracts.length) {
        base_self.input.contract_id = base_self.customers_contracts[0].id;
        base_self.input.contract =
          base_self.customers_contracts[0].code_contract;
      }
    }
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
